import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Image, StyleSheet, Text, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import Colors from '../../constants/Colors';
import Languages from '../../constants/Languages';
import * as Actions from '../../store/Actions';
import pantryRegionForUser from '../../utils/pantryRegionForUser';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.mediumBlue,
    alignItems: 'center',
    justifyContent: 'center',
  },
  headingText: {
    fontSize: 20,
    fontWeight: '900',
    lineHeight: 24,
    color: Colors.white,
    fontFamily: 'roboto-regular',
    width: 165,
    textAlign: 'center',
  },
  image: {
    height: 184,
    width: 184,
    resizeMode: 'contain',
    marginTop: 3,
    marginLeft: -10,
  },
});

class AccountCreatedScreen extends Component {
  static propTypes = {
    navigation: PropTypes.objectOf(PropTypes.any).isRequired,
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  constructor(props) {
    super();
  }

  spinnerTimer = null;

  componentDidMount = () => {
    const { actions, registration, navigation } = this.props;
    const { user } = registration;
    actions.getPantries(null, Boolean(user && user.id), pantryRegionForUser(user));
    this.spinnerTimer = setTimeout(() => {
      actions.onboardingCompleted(user, () => {
        navigation.navigate('a');
      });
    }, 3000);
  };

  componentWillUnmount() {
    if (this.spinnerTimer) clearTimeout(this.spinnerTimer);
  }

  render() {
    const { registration } = this.props;
    const { language } = registration;
    const translation = Languages.translations[language?.name || 'en'];

    return (
      <SafeAreaView style={{ flex: 1 }} edges={['top', 'left', 'right', 'bottom']}>
        <View style={styles.container}>
          <Image source={require('../../assets/images/plentiful-logo.png')} style={styles.image} />
          <Text style={styles.headingText}>{translation.account_created},</Text>
          <Text style={styles.headingText}>{translation.get_started}!</Text>
        </View>
      </SafeAreaView>
    );
  }
}

function mapStateToProps(state) {
  return {
    registration: state.registration,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountCreatedScreen);
